import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import { getStrapiMedia } from "../../../utils/utils";
import "./Slider.scss";

import { SliderComponent_Plain } from "../../../types/components/shared/SliderComponent.ts";
import { Vacancy_Plain } from "../../../types/api/vacancy.ts";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../hooks/useIsMobile";
import VideoSliderItem from "../../VideoSliderItem/VideoSliderItem";

const Slider = ({
  data,
  vacancy,
}: {
  data: SliderComponent_Plain;
  vacancy: Vacancy_Plain;
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const isVideo =
    data.image?.mime == "video/mp4" || data.image?.mime == "video/webm";

  return (
    <section className="main-slider main-slider_career">
      {data.image ? (
        isVideo ? (
          // Мобілка з imageMob: відео не рендериться взагалі, лише картинка
          isMobile && data.imageMob ? (
            <img src={getStrapiMedia(data.imageMob.url)} alt={data.title} />
          ) : (
            <VideoSliderItem
              videoUrl={data.image.url}
              mimeType={data.image.mime}
              posterUrl={data.videoPoster?.url}
              isActive={true}
              priority={true}
            />
          )
        ) : (
          <img src={getStrapiMedia(data.image.url)} alt={data.title} />
        )
      ) : (
        ""
      )}
      <div className="wrapper">
        <div className="box-career-title">
          <h1 className="career-title">
            {data.title}
            <div className="career-title__text">
              {t("A place where opportunities")}
            </div>
            <div className="career-title__text">{t("find fulfillment")}</div>
            <div className="career-title__text">
              {t("Career opportunities")}
            </div>
          </h1>
        </div>
        <div className="career-text">
          <div className="career-text__left">
            <p>{data.description}</p>
          </div>
          {vacancy && vacancy.vacancy.title ? (
            <div className="career-text__right">
              <a href="#" className="btn-career">
                <div className="btn-career__img">
                  <img src="/img/img-connect-mini.jpg" alt={data.title} />
                </div>
                <div className="btn-career__inf">
                  <div className="btn-career__looking">
                    {t("We are looking for")}
                    <span>{vacancy.vacancy.title}</span>
                  </div>
                  <span className="btn-career__all">
                    {t("All Vacancies")}
                    <span className="btn-career__all-icon"></span>
                  </span>
                </div>
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </section>
  );
};

export default Slider;
